// src/pages/Pricing.tsx
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import pricingCakeImage from "@/assets/pricing-cake.jpg";

export const Pricing = () => {
  // NEW STATE: stores the dynamic URL, defaults to local asset
  const [pricingUrl, setPricingUrl] = useState<string>(pricingCakeImage);
  
  // NEW EFFECT: Fetch the pricing image URL
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // CHANGED: Fetch the pricing image by ID
        const r = await fetch("/api/site-image?id=pricing", { method: "GET" });
        const j = await r.json();
        if (alive && j?.ok && j.url) setPricingUrl(j.url);
      } catch { /* ignore and use local defaults */ }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <section id="pricing" className="py-24 bg-gradient-to-b from-background to-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl text-primary mb-6">
            Cake Pricing
          </h2>
          <p className="subheading max-w-3xl mx-auto mb-4">THOUGHTFULLY DESIGNED FOR YOUR SPECIAL EVENT</p>
          <p className="max-w-3xl mx-auto leading-relaxed text-muted-foreground">
            Our cakes and other goodies are thoughtfully designed for your special event and are individually priced. However, to give you an idea of what to expect, we have given below some pricing information for each of our products.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="space-y-8">
              <div className="space-y-6">
                <div className="flex justify-between items-center border-b border-muted pb-4">
                  <span className="text-lg font-medium text-foreground">Custom Cakes</span>
                  <span className="text-lg font-semibold text-primary">$150 & up</span>
                </div>
                <div className="flex justify-between items-center border-b border-muted pb-4">
                  <span className="text-lg font-medium text-foreground">Sculpted Cakes</span>
                  <span className="text-lg font-semibold text-primary">$300 & up</span>
                </div>
                <div className="flex justify-between items-center border-b border-muted pb-4">
                  <span className="text-lg font-medium text-foreground">Wedding Cakes</span>
                  <span className="text-lg font-semibold text-primary">$500 & up</span>
                </div>
                <div className="flex justify-between items-center border-b border-muted pb-4">
                  <span className="text-lg font-medium text-foreground">Cupcakes (per dozen)</span>
                  <span className="text-lg font-semibold text-primary">$40 & up</span>
                </div>
                <div className="flex justify-between items-center border-b border-muted pb-4">
                  <span className="text-lg font-medium text-foreground">Have something else in mind?</span>
                  <span className="text-lg font-semibold text-primary">Get a quote</span>
                </div>
              </div>
              
              <div className="text-center">
                <Button
                  size="lg"
                  onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
                  className="
                    bg-[var(--about-btn-bg)]
                    text-[var(--about-btn-text)]
                    hover:bg-[var(--about-btn-hover-bg)]
                    hover:text-[var(--about-btn-hover-text)]
                    font-semibold px-8 py-4
                  "
                >
                  Order Now
                </Button>
              </div>
            </div>
          </div>
          
          <div className="order-1 lg:order-2 hidden lg:block">
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white/90 backdrop-blur-sm elegant-shadow p-3">
              <img
                src={pricingUrl} // <-- DYNAMIC SOURCE
                alt="Elegant wedding cake with multiple tiers and decorative elements"
                className="rounded-xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};